import { useMutation, useQuery } from '@tanstack/react-query';
import { apiGet, apiSend, http } from '../lib/api';
import type { PublicBooking, PublicProductDetail, RackCatalogue } from '../lib/types';

export function useRackCatalogue(qrToken: string | undefined) {
  return useQuery({
    queryKey: ['public-rack', qrToken],
    enabled: !!qrToken,
    staleTime: 10_000,
    queryFn: () => apiGet<RackCatalogue>(`/public/rack/${qrToken}`),
  });
}

export function useProductDetail(assignmentId: string | undefined) {
  return useQuery({
    queryKey: ['public-product', assignmentId],
    enabled: !!assignmentId,
    queryFn: () => apiGet<PublicProductDetail>(`/public/product/${assignmentId}`),
  });
}

export function recordProductView(assignmentId: string) {
  // fire and forget
  http.post(`/public/product/${assignmentId}/view`).catch(() => {});
}

export interface BookingPayload {
  visitor: {
    name: string;
    mobile: string;
    email?: string;
    companyName?: string;
    notes?: string;
  };
  items: { assignmentId: string; quantity: number }[];
}

export function useSubmitBooking() {
  return useMutation({
    mutationFn: (payload: BookingPayload) => apiSend<PublicBooking>('post', '/public/bookings', payload),
  });
}

export function useBookingLookup() {
  return useMutation({
    mutationFn: (v: { bookingNumber: string; mobile: string }) =>
      apiSend<PublicBooking>('post', `/public/bookings/${encodeURIComponent(v.bookingNumber)}/lookup`, {
        mobile: v.mobile,
      }),
  });
}
